import script from "./cpt-iconfont.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-iconfont.vue?vue&type=script&setup=true&lang=js"

import "./cpt-iconfont.vue?vue&type=style&index=0&id=bab0e6c2&lang=css"

const __exports__ = script;

export default __exports__